import squashKind from './squash-kind';

// The catalog descriptions guide the model; this copy is what people read.
const TOOL_SUMMARIES: Record<string, string> = {
  baselayer: 'Business search with derived KYB risk signals.',
  browser: 'Drives a browser through vendor portals, registries, and sites that need a login or a bot check.',
  entity_duplicates:
    'Other entities at your organization sharing PII or a device, with their status, label, tags, onboardings, and device insights.',
  comply_advantage_screening:
    'Screens a person against sanctions, PEP, and adverse-media watchlists, with per-category hits.',
  grail_pay_account_intelligence: 'US bank-account verification with a confidence score and decisioning insights.',
  idology_expect_id: 'Identity verification with risk signals.',
  incode_ekyb_cn: 'Verifies a China-registered business: name, tax ID, address, and beneficial owners.',
  incode_ekyc_ca_fintrac:
    'Matches name, date of birth, and address against credit-bureau records, with the credit file number FINTRAC requires.',
  incode_ekyc_ca_res_credit: 'Matches name, date of birth, address, and phone against residential and credit records.',
  lexis_flex_id: 'Identity verification with risk signals.',
  osint: 'Web search and page reading for open-source research, with citations.',
  sentilink_application_risk: 'Synthetic-identity and ID-theft scoring for an application.',
  sentilink_first_party_fraud: 'First-party fraud scoring for an application.',
  sumsub_applicant_fetch: 'A complete snapshot of one applicant: status, documents, AML case, risk labels, timeline.',
  sumsub_applicant_write: 'Adds a case note or appends tags to an applicant.',
  trans_union_tru_vision_resident_screening: 'Credit, criminal, and eviction recommendations for a rental applicant.',
  trustfull_onboarding: 'Digital-footprint score from email, phone, IP, and name, with risk and trust reason codes.',
  twilio: 'Line type, carrier, and phone risk signals.',
  unit21_alert_fetch: 'The full record for one alert.',
  unit21_alert_note_create: 'Adds a note to an alert.',
  unit21_alert_update: 'Writes a disposition note back to an alert.',
};

const summariesByKind = new Map(Object.entries(TOOL_SUMMARIES).map(([kind, summary]) => [squashKind(kind), summary]));

const toolSummary = (kind: string, fallback: string): string => summariesByKind.get(squashKind(kind)) ?? fallback;

export { toolSummary };
